import { useMemo } from 'react';
import { Skeleton } from '@mui/material';
import Text from 'src/components/Text';
import { useGetTransactionsSummary } from 'src/hooks/transactions';
import { filterProp } from 'src/interfaces/transactionsFilters';

import { withDefaultRange } from '../utils';
import { hasAnyFilterValue } from '../utils/urlFilters';

import { buildKpis } from './utils';
import { styles } from './styles';

interface MetricsSummaryProps {
  filter: filterProp;
  totalFromList?: number;
}

const KPI_LABELS = ['Total de pagos', 'TPV total', 'Ticket promedio', 'Tasa de aprobación', '% Canceladas'];

/**
 * Barra de 5 KPIs resumen sobre la tabla de la tab Descarga (H6). Formato es-AR.
 * Skeleton mientras carga; em dash + reintento ante error (sin romper la tabla).
 */
const MetricsSummary = ({ filter, totalFromList }: MetricsSummaryProps) => {
  const { classes } = styles();

  // El listado aplica el mismo default (ver TransactionsComponent): KPIs y tabla
  // deben describir SIEMPRE el mismo universo.
  const effectiveFilter = useMemo<filterProp>(
    () => withDefaultRange(filter, hasAnyFilterValue(filter)),
    [filter]
  );

  const { data, isFetching, isError, refetch } = useGetTransactionsSummary(effectiveFilter);

  const kpis = buildKpis(data?.data, totalFromList, isError);
  const values = [kpis.totalPayments, kpis.tpvTotal, kpis.averageTicket, kpis.approvalRate, kpis.canceledRate];

  return (
    <div className={classes.container} aria-label="metrics-summary">
      {KPI_LABELS.map((label, index) => (
        <div key={label} className={classes.card}>
          <Text variant="Caption-Medium">{label}</Text>
          {isFetching ? (
            <Skeleton variant="text" width={90} height={28} />
          ) : (
            <Text variant="H3-Regular">{values[index]}</Text>
          )}
        </div>
      ))}
      {isError && !isFetching && (
        <button type="button" className={classes.retry} onClick={() => refetch()}>
          Reintentar
        </button>
      )}
    </div>
  );
};

export default MetricsSummary;
